function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M134.7 1.3l.2 24.5",
  stroke: "#019bda",
  strokeWidth: 3,
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M160.1 20.8c-.2.2-.5.3-.8.3-.3 0-.3-.1-.4-.2-.4-.6.8-2.5 2-4.2.1 1.7 0 3.4-.8 4.1zm-5.8 3.5c-.5.5-1.2.7-2 .7-.7 0-1.4-.2-1.8-.6-.6-.6-.9-1.4-.8-2.3.2-1.7 1.5-3.3 2.9-4.8l.4.5c1.7 2.1 3.5 4.4 1.3 6.5zm23.6-12.9h-.2c-.1 0-.1.1-.1.1-.5.8-2 2.4-2 2.4-.9 1-2 2-2.7 2-1.1 0-.3-1.8 1.1-4.7.1-.2.3-.5.4-.4.2.2.1.8.1 1.1l.5.1c.1-.5 0-2.1-.5-2.6-.1-.1-.3-.2-.5-.2-1.1.1-2 2.1-3.2 5.2l-1.3 3c-.4 0 1.6-5.2 1-6.1l-2-.5c-.4 0-.8.3-1.2.7.2-.9.2-1.3 0-1.4l-1.3-.5c-.8-.3-2.1 1.8-2.9 3-.1.2-.4.7-.8 1.2 0-1.1.3-3.4.3-3.4h-1.7l-.4 1.6c-.1.4-.4 1.1-.9 1.8-.2.3-.4.6-.7.8-.3.2-.6.4-.9.2-.2-.1-.4-.5-.4-.9s.1-1 .2-1.4l.9-2.1h-1.4l-.1.1-1.5 2.4c-.6 1-1.5 2-2.4 3-2.3-2.9-5.4-5.8-6.2-9.3-.2-1 .1-2.1.6-3 .6-1.1 2.1-2 2.8-2s1.4.3 2.1.8c.7.5 1.1 1.2 1.1 1.9 0 0 0 .1.1.2h.2c.1 0 .1 0 .2-.1.1-.8-.4-1.8-1.3-2.4-1.6-1.1-3.5-1.2-5.2-.3-1.9 1-2.9 3-2.5 4.9.6 2.9 2.7 5.3 4.8 7.7.8.9 1.5 1.7 2.1 2.6-1.5 1.6-2.8 3.2-3.1 5.1-.1 1 .2 2 .9 2.7.5.5 1.3.8 2.2.8.3 0 1.1 0 2-.2.4-.1 1.4-.4 1.8-.8 2.7-2.5-.4-5.5-2-7.7l-.4-.6c1-1 2-2.1 2.6-3.2-.1.7-.1 1.4.4 1.9.6.6 1.2.6 1.7.5 1.1-.2 2-1.4 2.5-2.4v1.6l.1 1.3c-1.7 2.3-2.9 4.3-2.4 5.2.1.2.3.4.8.4.2 0 1.5 0 2.3-.4 1.4-.8 1.1-3.9.9-6.5.6-.8 1-1.3 1.2-1.7.9-1.5 1.9-2.8 2.2-2.8.2.5-.7 3.6-1.7 6.4h1.7s.7-2.1 1.2-3.9c.6-.7 1.1-1.2 1.4-1.3 0 0 .2 0 .3.2 0 .1.1.2.1.2-.1 1.8-1.7 5.7-1 6.7 0 .1.1.1.1.2.2.2.4.3.6.3.8 0 1.4-1.4 2.4-3.8 0 .4.1.8.3 1.1.2.3.6.5 1.1.5 1.3 0 3.3-2 4.7-3.9 0 0 .5-.7.8-1.1v-.2c.2 0 .2-.1.1-.1m1.6-4.2h10.4v1.3h-4.4v10.7h-1.7V8.4h-4.4l.1-1.2zm14.9 0h2l4.5 12h-1.7l-1.2-3h-5.3l-1.2 3h-1.8l4.7-12zm-1.3 7.7h4.5L195.4 9l-2.3 5.9zm12.2 2.9h6v1.3h-7.6v-12h1.7v10.7zm10-10.7v5.5l6-5.5h2.3l-5.9 5.4 6.2 6.6h-2.2l-5.2-5.5-1.3 1.2v4.3h-1.7v-12h1.8z",
  fill: "#019bda"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__a",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__a",
  overflow: "visible"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.7c.1-.2.2-.2.2 0l1.4 3.1c.1.1.1.2-.2.2H6.5c-.2 0-.3-.1-.2-.2L8 11.7zm2.7 5.4c.1.3.4.9.4 1.2 0 .5-.9.4-.9.7 0 .1.2.1.3.1.4 0 .8-.1 1.2-.1.6 0 1.2.1 1.8.1.1 0 .2 0 .2-.1 0-.3-.8 0-1.3-.6-.3-.4-.5-1-.7-1.5l-3-6.6c0-.1-.1-.5-.3-.5-.2 0-.2.2-1.1 1.8l-3.4 6.5c-.4.7-1 .5-1 .8 0 .1 0 .1.1.1.4 0 .8-.1 1.1-.1.4 0 .8.1 1.2.1.2 0 .4 0 .4-.2 0-.3-1 .1-1-.8 0-.2.1-.4.1-.4l.9-1.8c.1-.3.4-.3.7-.3h3.2c.4 0 .5.2.6.5l.5 1.1z",
  clipPath: "url(#logo-mobile_inline_svg__b)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__c",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__c",
  overflow: "visible"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.7c.1-.2.2-.2.2 0l1.4 3.1c.1.1.1.2-.2.2H6.5c-.2 0-.3-.1-.2-.2L8 11.7zm2.7 5.4c.1.3.4.9.4 1.2 0 .5-.9.4-.9.7 0 .1.2.1.3.1.4 0 .8-.1 1.2-.1.6 0 1.2.1 1.8.1.1 0 .2 0 .2-.1 0-.3-.8 0-1.3-.6-.3-.4-.5-1-.7-1.5l-3-6.6c0-.1-.1-.5-.3-.5-.2 0-.2.2-1.1 1.8l-3.4 6.5c-.4.7-1 .5-1 .8 0 .1 0 .1.1.1.4 0 .8-.1 1.1-.1.4 0 .8.1 1.2.1.2 0 .4 0 .4-.2 0-.3-1 .1-1-.8 0-.2.1-.4.1-.4l.9-1.8c.1-.3.4-.3.7-.3h3.2c.4 0 .5.2.6.5l.5 1.1z",
  clipPath: "url(#logo-mobile_inline_svg__d)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__e",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__e",
  overflow: "visible"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.7c.1-.2.2-.2.2 0l1.4 3.1c.1.1.1.2-.2.2H6.5c-.2 0-.3-.1-.2-.2L8 11.7zm2.7 5.4c.1.3.4.9.4 1.2 0 .5-.9.4-.9.7 0 .1.2.1.3.1.4 0 .8-.1 1.2-.1.6 0 1.2.1 1.8.1.1 0 .2 0 .2-.1 0-.3-.8 0-1.3-.6-.3-.4-.5-1-.7-1.5l-3-6.6c0-.1-.1-.5-.3-.5-.2 0-.2.2-1.1 1.8l-3.4 6.5c-.4.7-1 .5-1 .8 0 .1 0 .1.1.1.4 0 .8-.1 1.1-.1.4 0 .8.1 1.2.1.2 0 .4 0 .4-.2 0-.3-1 .1-1-.8 0-.2.1-.4.1-.4l.9-1.8c.1-.3.4-.3.7-.3h3.2c.4 0 .5.2.6.5l.5 1.1z",
  clipPath: "url(#logo-mobile_inline_svg__f)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__g",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__h"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__g",
  overflow: "visible"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.7c.1-.2.2-.2.2 0l1.4 3.1c.1.1.1.2-.2.2H6.5c-.2 0-.3-.1-.2-.2L8 11.7zm2.7 5.4c.1.3.4.9.4 1.2 0 .5-.9.4-.9.7 0 .1.2.1.3.1.4 0 .8-.1 1.2-.1.6 0 1.2.1 1.8.1.1 0 .2 0 .2-.1 0-.3-.8 0-1.3-.6-.3-.4-.5-1-.7-1.5l-3-6.6c0-.1-.1-.5-.3-.5-.2 0-.2.2-1.1 1.8l-3.4 6.5c-.4.7-1 .5-1 .8 0 .1 0 .1.1.1.4 0 .8-.1 1.1-.1.4 0 .8.1 1.2.1.2 0 .4 0 .4-.2 0-.3-1 .1-1-.8 0-.2.1-.4.1-.4l.9-1.8c.1-.3.4-.3.7-.3h3.2c.4 0 .5.2.6.5l.5 1.1z",
  clipPath: "url(#logo-mobile_inline_svg__h)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__i",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__j"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__i",
  overflow: "visible"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 17.6c0 1.5-1.1 1-1.1 1.4 0 .1 0 .1.2.1h2.3c.1 0 .1-.1.1-.1 0-.3-1.1.1-1.1-.9v-4.5c0-.2 0-.2.1-.2s.2.2.3.2l5.2 5.3c.3.2.4.3.5.3.1 0 .1-.2.1-.5v-6.3c0-.8.7-.6.7-.9 0-.1 0-.1-.1-.1h-2.3c-.1 0-.1 0-.1.1 0 .4 1.4-.1 1.4 1.4V17.6s-.1 0-.1-.1l-5.8-5.8c-.1-.1-.2-.3-.3-.3h-1.2c-.1 0-.2 0-.2.1 0 .4 1.5-.2 1.5 2l-.1 4.1z",
  clipPath: "url(#logo-mobile_inline_svg__j)"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__k",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__l"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__k",
  overflow: "visible"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 17.6c0 1.5-1.1 1-1.1 1.4 0 .1 0 .1.2.1h2.3c.1 0 .1-.1.1-.1 0-.3-1.1.1-1.1-.9v-4.5c0-.2 0-.2.1-.2s.2.2.3.2l5.2 5.3c.3.2.4.3.5.3.1 0 .1-.2.1-.5v-6.3c0-.8.7-.6.7-.9 0-.1 0-.1-.1-.1h-2.3c-.1 0-.1 0-.1.1 0 .4 1.4-.1 1.4 1.4V17.6s-.1 0-.1-.1l-5.8-5.8c-.1-.1-.2-.3-.3-.3h-1.2c-.1 0-.2 0-.2.1 0 .4 1.5-.2 1.5 2l-.1 4.1h0z",
  clipPath: "url(#logo-mobile_inline_svg__l)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__m",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref22 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__n"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__m",
  overflow: "visible"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 17.6c0 1.5-1.1 1-1.1 1.4 0 .1 0 .1.2.1h2.3c.1 0 .1-.1.1-.1 0-.3-1.1.1-1.1-.9v-4.5c0-.2 0-.2.1-.2s.2.2.3.2l5.2 5.3c.3.2.4.3.5.3.1 0 .1-.2.1-.5v-6.3c0-.8.7-.6.7-.9 0-.1 0-.1-.1-.1h-2.3c-.1 0-.1 0-.1.1 0 .4 1.4-.1 1.4 1.4V17.6s-.1 0-.1-.1l-5.8-5.8c-.1-.1-.2-.2-.3-.2h-1.2c-.1 0-.2 0-.2.1 0 .4 1.5-.2 1.5 2l-.1 4z",
  clipPath: "url(#logo-mobile_inline_svg__n)"
});

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__o",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref25 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__p"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__o",
  overflow: "visible"
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 17.6c0 1.5-1.1 1-1.1 1.4 0 .1 0 .1.2.1h2.3c.1 0 .1-.1.1-.1 0-.3-1.1.1-1.1-.9v-4.5c0-.2 0-.2.1-.2s.2.2.3.2l5.2 5.3c.3.2.4.3.5.3.1 0 .1-.2.1-.5v-6.3c0-.8.7-.6.7-.9 0-.1 0-.1-.1-.1h-2.3c-.1 0-.1 0-.1.1 0 .4 1.4-.1 1.4 1.4V17.6s-.1 0-.1-.1l-5.8-5.8c-.1-.1-.2-.2-.3-.2h-1.2c-.1 0-.2 0-.2.1 0 .4 1.5-.2 1.5 2l-.1 4z",
  clipPath: "url(#logo-mobile_inline_svg__p)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__q",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref28 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__r"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__q",
  overflow: "visible"
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6 11.6c-.1-1.5 1.1-1 1.1-1.4 0-.1-.1-.2-.1-.2-.2 0-.4.1-.7.1-.1 0-.5-.1-.7-.1-.2 0-.3.3-.4.4l-3.4 6.1c-.2.4-.4.7-.4.7-.1 0-.2-.1-.3-.4l-3.4-6.5c-.1-.1-.1-.4-.3-.4-.3 0-.5.1-.8.1-.3 0-.5-.1-.8-.1-.1 0-.2 0-.2.1 0 .4 1.4-.3 1.4 2.7 0 1.4-.2 2.7-.3 4.8-.1 1.3-1 .8-1 1.2 0 .1 0 .2.1.2.3 0 .5-.1 1.2-.1.4 0 1.1.1 1.3.1.2 0 .4 0 .4-.1 0-.5-1.4.1-1.3-1.6l.2-4.5c0-.1.1-.2.1-.2.1 0 .1 0 .2.1l3.1 5.7c0 .1.1.4.3.4.1 0 .4-.5.4-.6l3-5.4c.1-.3.3-.4.4-.4.1 0 .2.2.2.5l.1 5c0 .9-.9.7-.9 1.1 0 .1 0 .1.2.1.4 0 .8-.1 1.3-.1.6 0 1.1.1 1.3.1.2 0 .3 0 .3-.1 0-.4-1.1 0-1.1-1.1l-.5-6.2z",
  clipPath: "url(#logo-mobile_inline_svg__r)"
});

var _ref30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__s",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref31 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__t"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__s",
  overflow: "visible"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6 11.6c-.1-1.5 1.1-1 1.1-1.4 0-.1-.1-.2-.1-.2-.2 0-.4.1-.7.1-.1 0-.5-.1-.7-.1-.2 0-.3.3-.4.4l-3.4 6.1c-.2.4-.4.7-.4.7-.1 0-.2-.1-.3-.4l-3.4-6.5c-.1-.1-.1-.4-.3-.4-.3 0-.5.1-.8.1-.3 0-.5-.1-.8-.1-.1 0-.2 0-.2.1 0 .4 1.4-.3 1.4 2.7 0 1.4-.2 2.7-.3 4.8-.1 1.3-1 .8-1 1.2 0 .1 0 .2.1.2.3 0 .5-.1 1.2-.1.4 0 1.1.1 1.3.1.2 0 .4 0 .4-.1 0-.5-1.4.1-1.3-1.6l.2-4.5c0-.1.1-.2.1-.2.1 0 .1 0 .2.1l3.1 5.7c0 .1.1.4.3.4.1 0 .4-.5.4-.6l3-5.4c.1-.3.3-.4.4-.4.1 0 .2.2.2.5l.1 5c0 .9-.9.7-.9 1.1 0 .1 0 .1.2.1.4 0 .8-.1 1.3-.1.6 0 1.1.1 1.3.1.2 0 .3 0 .3-.1 0-.4-1.1 0-1.1-1.1l-.5-6.2z",
  clipPath: "url(#logo-mobile_inline_svg__t)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__u",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref34 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__v"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__u",
  overflow: "visible"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6 11.6c-.1-1.5 1.1-1 1.1-1.4 0-.1-.1-.2-.1-.2-.2 0-.4.1-.7.1-.1 0-.5-.1-.7-.1-.2 0-.3.3-.4.4l-3.4 6.1c-.2.4-.4.7-.4.7-.1 0-.2-.1-.3-.4l-3.4-6.5c-.1-.1-.1-.4-.3-.4-.3 0-.5.1-.8.1-.3 0-.5-.1-.8-.1-.1 0-.2 0-.2.1 0 .4 1.4-.3 1.4 2.7 0 1.4-.2 2.7-.3 4.8-.1 1.3-1 .8-1 1.2 0 .1 0 .2.1.2.3 0 .5-.1 1.2-.1.4 0 1.1.1 1.3.1.2 0 .4 0 .4-.1 0-.5-1.4.1-1.3-1.6l.2-4.5c0-.1.1-.2.1-.2.1 0 .1 0 .2.1l3.1 5.7c0 .1.1.4.3.4.1 0 .4-.5.4-.6l3-5.4c.1-.3.3-.4.4-.4.1 0 .2.2.2.5l.1 5c0 .9-.9.7-.9 1.1 0 .1 0 .1.2.1.4 0 .8-.1 1.3-.1.6 0 1.1.1 1.3.1.2 0 .3 0 .3-.1 0-.4-1.1 0-1.1-1.1l-.5-6.2z",
  clipPath: "url(#logo-mobile_inline_svg__v)"
});

var _ref36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__w",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref37 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__x"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__w",
  overflow: "visible"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6 11.6c-.1-1.5 1.1-1 1.1-1.4 0-.1-.1-.2-.1-.2-.2 0-.4.1-.7.1-.1 0-.5-.1-.7-.1-.2 0-.3.3-.4.4l-3.4 6.1c-.2.4-.4.7-.4.7-.1 0-.2-.1-.3-.4l-3.4-6.5c-.1-.1-.1-.4-.3-.4-.3 0-.5.1-.8.1-.3 0-.5-.1-.8-.1-.1 0-.2 0-.2.1 0 .4 1.4-.3 1.4 2.7 0 1.4-.2 2.7-.3 4.8-.1 1.3-1 .8-1 1.2 0 .1 0 .2.1.2.3 0 .5-.1 1.2-.1.4 0 1.1.1 1.3.1.2 0 .4 0 .4-.1 0-.5-1.4.1-1.3-1.6l.2-4.5c0-.1.1-.2.1-.2.1 0 .1 0 .2.1l3.1 5.7c0 .1.1.4.3.4.1 0 .4-.5.4-.6l3-5.4c.1-.3.3-.4.4-.4.1 0 .2.2.2.5l.1 5c0 .9-.9.7-.9 1.1 0 .1 0 .1.2.1.4 0 .8-.1 1.3-.1.6 0 1.1.1 1.3.1.2 0 .3 0 .3-.1 0-.4-1.1 0-1.1-1.1l-.5-6.2z",
  clipPath: "url(#logo-mobile_inline_svg__x)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__y",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref40 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__z"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__y",
  overflow: "visible"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.5 0-.5 0-.5-.4l-.3-2.1z",
  clipPath: "url(#logo-mobile_inline_svg__z)"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__A",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref43 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__B"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__A",
  overflow: "visible"
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.5 0-.5 0-.5-.4l-.3-2.1h0z",
  clipPath: "url(#logo-mobile_inline_svg__B)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__C",
  d: "M2.8-8.2h100.4v27.5H2.8z"
}));

var _ref46 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__D"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__C",
  overflow: "visible"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.5 0-.5 0-.5-.4l-.3-2.1z",
  clipPath: "url(#logo-mobile_inline_svg__D)"
});

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__E",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__F"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__E",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.6 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.5 0-.5 0-.5-.4l-.3-2.1h0z",
  clipPath: "url(#logo-mobile_inline_svg__F)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__G",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__H"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__G",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.7 12.4c0-.5 0-.7 1.2-.7 2.3 0 4.1 1.4 4.1 3.8 0 2.5-1.6 3.3-3.4 3.3-.5 0-1.5-.1-1.9-.5-.1-.1-.1-.6-.1-.8l.1-5.1zm-.9 5.6c0 1-.9.8-.9 1 0 .1 0 .1.1.1h3.3c3.4 0 4.7-1.7 4.7-4.2 0-2-2.1-3.5-4.3-3.5H43c-.1 0-.2 0-.2.1 0 .3 1-.1 1 1.1V18z",
  clipPath: "url(#logo-mobile_inline_svg__H)"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__I",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__J"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__I",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.7 12.4c0-.5 0-.7 1.2-.7 2.3 0 4.1 1.4 4.1 3.8 0 2.5-1.6 3.3-3.4 3.3-.5 0-1.5-.1-1.9-.5-.1-.1-.1-.6-.1-.8l.1-5.1zm-.9 5.6c0 1-.9.8-.9 1 0 .1 0 .1.1.1h3.3c3.4 0 4.7-1.7 4.7-4.2 0-2-2.1-3.5-4.3-3.5H43c-.1 0-.2 0-.2.1 0 .3 1-.1 1 1.1V18h0z",
  clipPath: "url(#logo-mobile_inline_svg__J)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__K",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__L"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__K",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.7 12.4c0-.5 0-.7 1.2-.7 2.3 0 4.1 1.4 4.1 3.8 0 2.5-1.6 3.3-3.4 3.3-.5 0-1.5-.1-1.9-.5-.1-.1-.1-.6-.1-.8l.1-5.1zm-.9 5.6c0 1-.9.8-.9 1 0 .1 0 .1.1.1h3.3c3.4 0 4.7-1.7 4.7-4.2 0-2-2.1-3.5-4.3-3.5H43c-.1 0-.2 0-.2.1 0 .3 1-.1 1 1.1V18z",
  clipPath: "url(#logo-mobile_inline_svg__L)"
}));

var _ref52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__M",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__N"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__M",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.7 12.4c0-.5 0-.7 1.2-.7 2.3 0 4.1 1.4 4.1 3.8 0 2.5-1.6 3.3-3.4 3.3-.5 0-1.5-.1-1.9-.5-.1-.1-.1-.6-.1-.8l.1-5.1zm-.9 5.6c0 1-.9.8-.9 1 0 .1 0 .1.1.1h3.3c3.4 0 4.7-1.7 4.7-4.2 0-2-2.1-3.5-4.3-3.5H43c-.1 0-.2 0-.2.1 0 .3 1-.1 1 1.1V18z",
  clipPath: "url(#logo-mobile_inline_svg__N)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__O",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__P"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__O",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 17.7c0 1.3-1.1.8-1.1 1.2 0 .1 0 .2.2.2.1 0 .2-.1 1.2-.1.8 0 1.8.1 2 .1.1 0 .2 0 .2-.1 0-.4-1.4-.1-1.4-1v-3.2c0-.1 0-.2.2-.2h5.3c.2 0 .1.1.1.3V18c0 .8-1 .6-1 .9 0 .2.2.2.3.2.3 0 .7-.1 1.6-.1.5 0 1 .1 1.3.1.1 0 .2-.1.2-.2 0-.3-1.3-.1-1.3-1v-6.8c0-.9 1-.7 1-.9 0-.1 0-.2-.4-.2-.3 0-.5.1-1 .1-.3 0-1-.1-1.5-.1-.2 0-.2.1-.2.1 0 .3 1.1.1 1.1 1v2.6s0 .4-.1.4h-5.2c-.2 0-.2-.1-.2-.2v-2.8c0-1 1-.7 1-1 0-.1 0-.1-.3-.1-.4 0-.9.1-1.3.1-.5 0-1-.1-1.6-.1-.1 0-.2 0-.2.1 0 .3 1.2 0 1.2 1l-.1 6.6z",
  clipPath: "url(#logo-mobile_inline_svg__P)"
}));

var _ref54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__Q",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__R"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__Q",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 17.7c0 1.3-1.1.8-1.1 1.2 0 .1 0 .2.2.2.1 0 .2-.1 1.2-.1.8 0 1.8.1 2 .1.1 0 .2 0 .2-.1 0-.4-1.4-.1-1.4-1v-3.2c0-.1 0-.2.2-.2h5.3c.2 0 .1.1.1.3V18c0 .8-1 .6-1 .9 0 .2.2.2.3.2.3 0 .7-.1 1.6-.1.5 0 1 .1 1.3.1.1 0 .2-.1.2-.2 0-.3-1.3-.1-1.3-1v-6.8c0-.9 1-.7 1-.9 0-.1 0-.2-.4-.2-.3 0-.5.1-1 .1-.3 0-1-.1-1.5-.1-.2 0-.2.1-.2.1 0 .3 1.1.1 1.1 1v2.6s0 .4-.1.4h-5.2c-.2 0-.2-.1-.2-.2v-2.8c0-1 1-.7 1-1 0-.1 0-.1-.3-.1-.4 0-.9.1-1.3.1-.5 0-1-.1-1.6-.1-.1 0-.2 0-.2.1 0 .3 1.2 0 1.2 1l-.1 6.6z",
  clipPath: "url(#logo-mobile_inline_svg__R)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__S",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__T"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__S",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 17.7c0 1.3-1.1.8-1.1 1.2 0 .1 0 .2.2.2.1 0 .2-.1 1.2-.1.8 0 1.8.1 2 .1.1 0 .2 0 .2-.1 0-.4-1.4-.1-1.4-1v-3.2c0-.1 0-.2.2-.2h5.3c.2 0 .1.1.1.3V18c0 .8-1 .6-1 .9 0 .2.2.2.3.2.3 0 .7-.1 1.6-.1.5 0 1 .1 1.3.1.1 0 .2-.1.2-.2 0-.3-1.3-.1-1.3-1v-6.8c0-.9 1-.7 1-.9 0-.1 0-.2-.4-.2-.3 0-.5.1-1 .1-.3 0-1-.1-1.5-.1-.2 0-.2.1-.2.1 0 .3 1.1.1 1.1 1v2.6c0 .1 0 .4-.1.4h-5.2c-.2 0-.2-.1-.2-.2v-2.8c0-1 1-.7 1-1 0-.1 0-.1-.3-.1-.4 0-.9.1-1.3.1-.5 0-1-.1-1.6-.1-.1 0-.2 0-.2.1 0 .3 1.2 0 1.2 1l-.1 6.6z",
  clipPath: "url(#logo-mobile_inline_svg__T)"
}));

var _ref56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__U",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__V"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__U",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 17.7c0 1.3-1.1.8-1.1 1.2 0 .1 0 .2.2.2.1 0 .2-.1 1.2-.1.8 0 1.8.1 2 .1.1 0 .2 0 .2-.1 0-.4-1.4-.1-1.4-1v-3.2c0-.1 0-.2.2-.2h5.3c.2 0 .1.1.1.3V18c0 .8-1 .6-1 .9 0 .2.2.2.3.2.3 0 .7-.1 1.6-.1.5 0 1 .1 1.3.1.1 0 .2-.1.2-.2 0-.3-1.3-.1-1.3-1v-6.8c0-.9 1-.7 1-.9 0-.1 0-.2-.4-.2-.3 0-.5.1-1 .1-.3 0-1-.1-1.5-.1-.2 0-.2.1-.2.1 0 .3 1.1.1 1.1 1v2.6c0 .1 0 .4-.1.4h-5.2c-.2 0-.2-.1-.2-.2v-2.8c0-1 1-.7 1-1 0-.1 0-.1-.3-.1-.4 0-.9.1-1.3.1-.5 0-1-.1-1.6-.1-.1 0-.2 0-.2.1 0 .3 1.2 0 1.2 1l-.1 6.6h0z",
  clipPath: "url(#logo-mobile_inline_svg__V)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__W",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__X"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__W",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M68 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.8-.1-.8-.1-.8-.5v-2z",
  clipPath: "url(#logo-mobile_inline_svg__X)"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__Y",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__Z"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__Y",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M68 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.8-.1-.8-.1-.8-.5v-2h0z",
  clipPath: "url(#logo-mobile_inline_svg__Z)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aa",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ab"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aa",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M68 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.8-.1-.8-.1-.8-.5v-2z",
  clipPath: "url(#logo-mobile_inline_svg__ab)"
}));

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ac",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ad"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ac",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M68 12.6c0-.7 0-.7 1.1-.7.5 0 1.8-.1 2.1.3.2.2 0 .8.3.8.1 0 .2-.1.2-1.3 0-.1 0-.2-.1-.2h-5.1c-.4 0-.4 0-.4.1s.3.2.4.2c.7.1.7.6.7 1.1v5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9v-2c0-.2 0-.3.2-.3h1.8c1 0 .6 1 1 1 .1 0 .1 0 .1-.1v-.9-1.1c0-.1 0-.2-.1-.2-.3 0 0 .9-1.2.9h-1.3c-.8-.1-.8-.1-.8-.5v-2h0z",
  clipPath: "url(#logo-mobile_inline_svg__ad)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ae",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__af"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ae",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.6 12.8c.1-.1.1-.1.2 0l1.2 2.6c.1.1.1.2-.2.2h-2.4c-.2 0-.2 0-.2-.2l1.4-2.6zm2.3 4.6c.1.3.4.8.4 1 0 .4-.7.3-.7.6 0 .1.2.1.3.1h2.5c.1 0 .2 0 .2-.1 0-.3-.7 0-1.1-.5-.3-.4-.4-.8-.6-1.2l-2.5-5.6c0-.1-.1-.4-.3-.4-.2 0-.2.2-.9 1.5l-2.9 5.6c-.3.6-.9.4-.9.7 0 .1 0 .1.1.1h2c.2 0 .3 0 .3-.2 0-.3-.9 0-.9-.7 0-.1 0-.3.1-.4l.8-1.5c.1-.2.3-.2.6-.2H78c.3 0 .4.2.5.4l.4.8z",
  clipPath: "url(#logo-mobile_inline_svg__af)"
}));

var _ref62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ag",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ah"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ag",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.6 12.8c.1-.1.1-.1.2 0l1.2 2.6c.1.1.1.2-.2.2h-2.4c-.2 0-.2 0-.2-.2l1.4-2.6zm2.3 4.6c.1.3.4.8.4 1 0 .4-.7.3-.7.6 0 .1.2.1.3.1h2.5c.1 0 .2 0 .2-.1 0-.3-.7 0-1.1-.5-.3-.4-.4-.8-.6-1.2l-2.5-5.6c0-.1-.1-.4-.3-.4-.2 0-.2.2-.9 1.5l-2.9 5.6c-.3.6-.9.4-.9.7 0 .1 0 .1.1.1h2c.2 0 .3 0 .3-.2 0-.3-.9 0-.9-.7 0-.1 0-.3.1-.4l.8-1.5c.1-.2.3-.2.6-.2H78c.3 0 .4.2.5.4l.4.8z",
  clipPath: "url(#logo-mobile_inline_svg__ah)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ai",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aj"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ai",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.6 12.8c.1-.1.1-.1.2 0l1.2 2.6c.1.1.1.2-.2.2h-2.4c-.2 0-.2 0-.2-.2l1.4-2.6zm2.3 4.6c.1.3.4.8.4 1 0 .4-.7.3-.7.6 0 .1.2.1.3.1h2.5c.1 0 .2 0 .2-.1 0-.3-.7 0-1.1-.5-.3-.4-.4-.8-.6-1.2l-2.5-5.6c0-.1-.1-.4-.3-.4-.2 0-.2.2-.9 1.5l-2.9 5.6c-.3.6-.9.4-.9.7 0 .1 0 .1.1.1h2c.2 0 .3 0 .3-.2 0-.3-.9 0-.9-.7 0-.1 0-.3.1-.4l.8-1.5c.1-.2.3-.2.6-.2H78c.3 0 .4.2.5.4l.4.8z",
  clipPath: "url(#logo-mobile_inline_svg__aj)"
}));

var _ref64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ak",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__al"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ak",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.6 12.8c.1-.1.1-.1.2 0l1.2 2.6c.1.1.1.2-.2.2h-2.4c-.2 0-.2 0-.2-.2l1.4-2.6zm2.3 4.6c.1.3.4.8.4 1 0 .4-.7.3-.7.6 0 .1.2.1.3.1h2.5c.1 0 .2 0 .2-.1 0-.3-.7 0-1.1-.5-.3-.4-.4-.8-.6-1.2l-2.5-5.6c0-.1-.1-.4-.3-.4-.2 0-.2.2-.9 1.5l-2.9 5.6c-.3.6-.9.4-.9.7 0 .1 0 .1.1.1h2c.2 0 .3 0 .3-.2 0-.3-.9 0-.9-.7 0-.1 0-.3.1-.4l.8-1.5c.1-.2.3-.2.6-.2H78c.3 0 .4.2.5.4l.4.8z",
  clipPath: "url(#logo-mobile_inline_svg__al)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__am",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__an"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__am",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.4 12.5c0-.9.9-.7.9-.9 0-.1-.1-.2-.2-.2h-2.4c-.2 0-.2 0-.2.1 0 .2 1 .1 1 .7v5.5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9l-.2-5.1z",
  clipPath: "url(#logo-mobile_inline_svg__an)"
}));

var _ref66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ao",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ap"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ao",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.4 12.5c0-.9.9-.7.9-.9 0-.1-.1-.2-.2-.2h-2.4c-.2 0-.2 0-.2.1 0 .2 1 .1 1 .7v5.5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9l-.2-5.1z",
  clipPath: "url(#logo-mobile_inline_svg__ap)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aq",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ar"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aq",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.4 12.5c0-.9.9-.7.9-.9 0-.1-.1-.2-.2-.2h-2.4c-.2 0-.2 0-.2.1 0 .2 1 .1 1 .7v5.5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9l-.2-5.1z",
  clipPath: "url(#logo-mobile_inline_svg__ar)"
}));

var _ref68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__as",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__at"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__as",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.4 12.5c0-.9.9-.7.9-.9 0-.1-.1-.2-.2-.2h-2.4c-.2 0-.2 0-.2.1 0 .2 1 .1 1 .7v5.5c0 .5 0 .8-.3.9-.4.2-.5.2-.5.3 0 .1.1.1.2.1h4.3c.5 0 .8 0 1.2-.4.3-.3.6-.7.6-1.1 0 0 0-.1-.1-.1-.2 0-.6 1.1-3.4 1.1-1 0-.9-.3-.9-.9l-.2-5.1z",
  clipPath: "url(#logo-mobile_inline_svg__at)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__au",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__av"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__au",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.8 18.2c0 .7-1 .5-1 .8 0 .1 0 .1.1.1h2.7c.1 0 .1-.1.1-.1 0-.3-1 0-1-.9v-5.6c0-.6-.1-.5.5-.5H93c1.2 0 .6.8 1 .8.2 0 .1-.1.1-.2l-.1-.9c0-.2-.1-.3-.4-.3h-7.1c-.2 0-.2.3-.2.4l-.1 1.1c0 .1 0 .1.1.1.2 0 .2-.1.2-.2.2-.6.2-.8 1-.8h2c.2 0 .1.4.1.5l.2 5.7z",
  clipPath: "url(#logo-mobile_inline_svg__av)"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aw",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__ax"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aw",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.8 18.2c0 .7-1 .5-1 .8 0 .1 0 .1.1.1h2.7c.1 0 .1-.1.1-.1 0-.3-1 0-1-.9v-5.6c0-.6-.1-.5.5-.5H93c1.2 0 .6.8 1 .8.2 0 .1-.1.1-.2l-.1-.9c0-.2-.1-.3-.4-.3h-7.1c-.2 0-.2.3-.2.4l-.1 1.1c0 .1 0 .1.1.1.2 0 .2-.1.2-.2.2-.6.2-.8 1-.8h2c.2 0 .1.4.1.5l.2 5.7h0z",
  clipPath: "url(#logo-mobile_inline_svg__ax)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__ay",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__az"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__ay",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.8 18.2c0 .7-1 .5-1 .8 0 .1 0 .1.1.1h2.7c.1 0 .1-.1.1-.1 0-.3-1 0-1-.9v-5.6c0-.6-.1-.5.5-.5H93c1.2 0 .6.8 1 .8.2 0 .1-.1.1-.2l-.1-.9c0-.2-.1-.3-.4-.3h-7.1c-.2 0-.2.3-.2.4l-.1 1.1c0 .1 0 .1.1.1.2 0 .2-.1.2-.2.2-.6.2-.8 1-.8h2c.2 0 .1.4.1.5l.2 5.7z",
  clipPath: "url(#logo-mobile_inline_svg__az)"
}));

var _ref72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aA",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aB"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aA",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.8 18.2c0 .7-1 .5-1 .8 0 .1 0 .1.1.1h2.7c.1 0 .1-.1.1-.1 0-.3-1 0-1-.9v-5.6c0-.6-.1-.5.5-.5H93c1.2 0 .6.8 1 .8.2 0 .1-.1.1-.2l-.1-.9c0-.2-.1-.3-.4-.3h-7.1c-.2 0-.2.3-.2.4l-.1 1.1c0 .1 0 .1.1.1.2 0 .2-.1.2-.2.2-.6.2-.8 1-.8h2c.2 0 .1.4.1.5l.2 5.7h0z",
  clipPath: "url(#logo-mobile_inline_svg__aB)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aC",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aD"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aC",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M95.4 17.9c0 1.1-1 .7-1 1 0 .1 0 .2.1.2h2.7c.1 0 .2 0 .2-.1 0-.3-1.2-.1-1.2-.8v-2.7c0-.1 0-.2.1-.2h4.5c.1 0 .1.1.1.3v2.6c0 .7-.9.5-.9.8 0 .2.2.1.3.1h2.5c.1 0 .1-.1.1-.1 0-.3-1.1-.1-1.1-.9v-5.8c0-.8.8-.6.8-.8 0-.1 0-.2-.3-.2h-2.2c-.2 0-.2.1-.2.1 0 .2.9.1.9.8v2.2s0 .3-.1.3h-4.5c-.2 0-.2 0-.2-.2v-2.4c0-.8.9-.6.9-.8 0 0 0-.1-.2-.1H94.3c-.1 0-.2 0-.2.1 0 .2 1 0 1.1.8l.2 5.8z",
  clipPath: "url(#logo-mobile_inline_svg__aD)"
}));

var _ref74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aE",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aE",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M95.4 17.9c0 1.1-1 .7-1 1 0 .1 0 .2.1.2h2.7c.1 0 .2 0 .2-.1 0-.3-1.2-.1-1.2-.8v-2.7c0-.1 0-.2.1-.2h4.5c.1 0 .1.1.1.3v2.6c0 .7-.9.5-.9.8 0 .2.2.1.3.1h2.5c.1 0 .1-.1.1-.1 0-.3-1.1-.1-1.1-.9v-5.8c0-.8.8-.6.8-.8 0-.1 0-.2-.3-.2h-2.2c-.2 0-.2.1-.2.1 0 .2.9.1.9.8v2.2s0 .3-.1.3h-4.5c-.2 0-.2 0-.2-.2v-2.4c0-.8.9-.6.9-.8 0 0 0-.1-.2-.1H94.3c-.1 0-.2 0-.2.1 0 .2 1 0 1.1.8l.2 5.8z",
  clipPath: "url(#logo-mobile_inline_svg__aF)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aG",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aH"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aG",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M95.4 17.9c0 1.1-1 .7-1 1 0 .1 0 .2.1.2h2.7c.1 0 .2 0 .2-.1 0-.3-1.2-.1-1.2-.8v-2.7c0-.1 0-.2.1-.2h4.5c.1 0 .1.1.1.3v2.6c0 .7-.9.5-.9.8 0 .2.2.1.3.1h2.5c.1 0 .1-.1.1-.1 0-.3-1.1-.1-1.1-.9v-5.8c0-.8.8-.6.8-.8 0-.1 0-.2-.3-.2h-2.2c-.2 0-.2.1-.2.1 0 .2.9.1.9.8v2.2s0 .3-.1.3h-4.5c-.2 0-.2 0-.2-.2v-2.4c0-.8.9-.6.9-.8 0 0 0-.1-.2-.1H94.3c-.1 0-.2 0-.2.1 0 .2 1 0 1.1.8l.2 5.8z",
  clipPath: "url(#logo-mobile_inline_svg__aH)"
}));

var _ref76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aI",
  d: "M2.8-8.2h100.4v27.5H2.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aJ"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aI",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M95.4 17.9c0 1.1-1 .7-1 1 0 .1 0 .2.1.2h2.7c.1 0 .2 0 .2-.1 0-.3-1.2-.1-1.2-.8v-2.7c0-.1 0-.2.1-.2h4.5c.1 0 .1.1.1.3v2.6c0 .7-.9.5-.9.8 0 .2.2.1.3.1h2.5c.1 0 .1-.1.1-.1 0-.3-1.1-.1-1.1-.9v-5.8c0-.8.8-.6.8-.8 0-.1 0-.2-.3-.2h-2.2c-.2 0-.2.1-.2.1 0 .2.9.1.9.8v2.2s0 .3-.1.3h-4.5c-.2 0-.2 0-.2-.2v-2.4c0-.8.9-.6.9-.8 0 0 0-.1-.2-.1H94.3c-.1 0-.2 0-.2.1 0 .2 1 0 1.1.8l.2 5.8z",
  clipPath: "url(#logo-mobile_inline_svg__aJ)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aK",
  d: "M86.3 8.9h62.8v17.2H86.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aL"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aK",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M128.7 16.6l-4.4-7.1c-.4-.6-1.2-.8-1.9-.5l-.3.1c-.7.3-.9 1.1-.5 1.7L126 18c.4.6 1.2.8 1.9.5l.3-.1c.6-.4.9-1.1.5-1.8",
  clipPath: "url(#logo-mobile_inline_svg__aL)",
  fill: "#56a0d3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aM",
  d: "M86.3 8.9h62.8v17.2H86.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aN"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aM",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M123.6 16.6l-4.4-7.1c-.4-.6-1.2-.8-1.9-.5l-.3.1c-.7.3-.9 1.1-.5 1.7l4.4 7.1c.4.6 1.2.8 1.9.5l.3-.1c.7-.3.9-1.1.5-1.7",
  clipPath: "url(#logo-mobile_inline_svg__aN)",
  fill: "#56a0d3"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aO",
  d: "M86.3 8.9h62.8v17.2H86.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aP"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aO",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M118.6 16.6l-4.4-7.1c-.4-.6-1.2-.8-1.9-.5l-.3.1c-.7.3-.9 1.1-.5 1.7l4.4 7.1c.4.6 1.2.8 1.9.5l.3-.1c.6-.3.9-1.1.5-1.7",
  clipPath: "url(#logo-mobile_inline_svg__aP)",
  fill: "#56a0d3"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-mobile_inline_svg__aQ",
  d: "M86.3 8.9h62.8v17.2H86.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-mobile_inline_svg__aR"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-mobile_inline_svg__aQ",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M107.2 16.6l3.2-5.1c.4.6 1.4 2.3 1.8 2.9L110 18c-.4.6-1.2.8-1.9.5l-.3-.1c-.7-.4-1-1.2-.6-1.8",
  clipPath: "url(#logo-mobile_inline_svg__aR)",
  fill: "#56a0d3"
})));

function SvgLogoMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 226.1 27.8"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77);
}

export default SvgLogoMobileinline;